._section_p6adr_1 {
  margin-top: 12px; }

._section_p6adr_1._withoutFooter_p6adr_4 {
  padding-bottom: 19px; }

._footer_p6adr_7 {
  position: -webkit-sticky;
  position: sticky;
  bottom: 0;
  width: 304px;
  margin: 0 auto;
  background-color: #FFF;
  padding-bottom: 19px; }

._footerContent_p6adr_15 {
  display: flex;
  margin-top: 14px; }

._footerText_p6adr_19 {
  margin-left: 6px; }

._footerInfoIcon_p6adr_22 {
  width: 24px;
  height: 24px;
  fill: #7a92a5; }
